import "core-js/modules/es6.promise";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.regexp.search";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
import { templateMixin } from './templateMixin';
var DEFAULT_ITEMS_PER_PAGE = 10;
var ITEMS_PER_PAGE_RANGE = [10, 20, 50, 100];
var FETCH_LIST_DEBOUNCE_TIME_MS = 300;
var DEFAULT_TABLE_PAGINATION_OPTIONS = {
  page: 1,
  itemsPerPage: DEFAULT_ITEMS_PER_PAGE,
  sortBy: [],
  sortDesc: [],
  groupBy: [],
  groupDesc: [],
  multiSort: false,
  mustSort: false
};
export default {
  name: 'CoreListViewPage',
  mixins: [templateMixin],
  props: {
    /**
     * Function to fetch items
     * @type {Function}
     * @required
     * @param {Object} params (search: string, page: number, perPage: number, ...externalFetchParams)
     * @returns {Promise} (items: Array, total: number)
     */
    fetchItems: {
      type: Function,
      required: true
    },
    externalFetchParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    /**
     * Function to delete item
     * @type {Function}
     * @required
     * @param {Object} item (item from fetchItems request)
     */
    deleteItem: {
      type: Function,
      required: false,
      default: null
    },

    /**
     * Snack message to show after successful delete
     * @type {String}
     */
    deleteItemSnackMessage: {
      type: String,
      required: false,
      default: ''
    },

    /**
     * Snack message to show after error on delete
     * @type {String}
     */
    deleteItemErrorSnackMessage: {
      type: String,
      required: false,
      default: ''
    },

    /**
     * Table headers
     * @type {Array} [{ text: String (col label), value: String (item property key), align?: String, sortable?: Boolean }]
     */
    tableHeaders: {
      type: Array,
      required: true
    },

    /**
     * identifier key for items, needs to be unique and needs to exist in all items
     * @type {String}
     * @default 'id'
     */
    tableItemKey: {
      type: String,
      default: 'id'
    },

    /**
     * should the core-header be shown, or is this a headless list?
     * if unset, the header-buttons obviously will also not be shown, and all the attributes be ignored.
     * @type {Boolean}
     * @default true
     */
    showHeader: {
      type: Boolean,
      default: true
    },

    /**
     * Header buttons
     * @type {Array} [{ dataCy?: string, color?: string, type?: string, tooltip?: string, href?: string, target?: string, icon?: string, action?: string }]
     */
    headerButtons: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * Page headline
     * @type {String}
     */
    headline: {
      type: String,
      default: ''
    },

    /**
     * Page subtitle
     * @type {String}
     */
    subtitle: {
      type: String,
      default: ''
    },

    /**
     * Function to get the href for a row
     * @type {Function}
     * @param {Object} item
     * @returns {String}
     */
    rowHref: {
      type: Function,
      required: false,
      default: function _default() {
        return function () {
          return '#';
        };
      }
    },
    hasCreateButton: {
      type: Boolean,
      default: false
    },
    createButtonOnClick: {
      type: Function,
      default: undefined
    },
    createButtonHref: {
      type: String,
      default: ''
    },
    hasSearchBar: {
      type: Boolean,
      default: true
    },
    fetchErrorMessage: {
      type: String,
      required: true
    },
    isTemplatesList: {
      type: Boolean,
      required: false,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      textSearchValue: '',
      showDeletePrompt: false,
      isFetching: true,
      deleteItemError: null,
      itemToBeDeleted: null,
      items: [],
      totalItemsCount: 0,
      tablePaginationOptions: _objectSpread({}, DEFAULT_TABLE_PAGINATION_OPTIONS)
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    deletePromptTitle: function deletePromptTitle() {
      return this.$i18n_t('Core.ListViewPage.deleteItem.prompt.title');
    },
    deletePromptCancelButtonLabel: function deletePromptCancelButtonLabel() {
      return this.$i18n_t('Core.ListViewPage.deleteItem.prompt.cancelButton.label');
    },
    deletePromptDeleteButtonLabel: function deletePromptDeleteButtonLabel() {
      return this.$i18n_t('Core.ListViewPage.deleteItem.prompt.deleteButton.label');
    },
    tableFooterProps: function tableFooterProps() {
      return {
        itemsPerPageText: this.$i18n_t('Core.ListViewPage.tableFooter.itemsPerPageText'),
        itemsPerPageOptions: [].concat(ITEMS_PER_PAGE_RANGE)
      };
    },
    combinedHeaderButtons: function combinedHeaderButtons() {
      var buttons = _toConsumableArray(this.headerButtons);

      if (this.hasCreateButton !== false) {
        var createButton = {
          title: this.$i18n_t('Core.ListViewPage.createButton.label'),
          color: this.color,
          icon: 'fal fa-plus',
          onClick: this.createButtonOnClick,
          href: this.createButtonHref
        };

        if (typeof createButton.onClick !== 'function' && !createButton.href) {
          // navigate to current path + /new
          createButton.href = this.$router.resolve({
            path: "".concat(this.$route.path, "/new")
          }).href;
        }

        buttons.push(createButton);
      }

      return buttons;
    }
  }),
  watch: {
    tablePaginationOptions: {
      handler: function handler(newVal) {
        // store new pagination values in the route
        this.updateRouterParams({
          page: newVal.page,
          perPage: newVal.itemsPerPage,
          sortBy: newVal.sortBy[0],
          sortDirection: newVal.sortDesc[0] ? 'desc' : 'asc'
        }); // fetch new items

        this.callFetchItems();
      },
      deep: true
    },
    textSearchValue: {
      handler: function handler(newVal) {
        this.updateRouterParams({
          search: newVal
        });
        this.callFetchItems();
      }
    },
    externalFetchParams: {
      handler: function handler() {
        this.callFetchItems();
      },
      deep: true
    }
  },
  created: function created() {
    if (typeof this.fetchItems !== 'function') {
      console.warn('fetchItems function is not defined');
      return;
    }

    if (!Array.isArray(this.tableHeaders) || this.tableHeaders.length === 0) {
      console.warn('tableHeaders is not defined or empty');
      return;
    }

    var page = parseInt(this.$route.query.page, 10) || DEFAULT_TABLE_PAGINATION_OPTIONS.page;
    var itemsPerPage = parseInt(this.$route.query.perPage, 10) || DEFAULT_TABLE_PAGINATION_OPTIONS.itemsPerPage;
    var sortBy = this.$route.query.sortBy || DEFAULT_TABLE_PAGINATION_OPTIONS.sortBy[0];
    var sortDesc = this.$route.query.sortDirection || (DEFAULT_TABLE_PAGINATION_OPTIONS.sortDesc[0] ? 'desc' : 'asc');
    this.tablePaginationOptions = _objectSpread(_objectSpread({}, this.tablePaginationOptions), {}, {
      page: page,
      itemsPerPage: itemsPerPage,
      sortBy: [sortBy],
      sortDesc: [sortDesc === 'desc']
    });
    var textSearchValueFromQuery = this.$route.query.search || '';

    if (textSearchValueFromQuery) {
      this.textSearchValue = textSearchValueFromQuery;
    }

    this.callFetchItems();
  },
  methods: {
    callDeleteItem: function () {
      var _callDeleteItem = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                this.isDeleting = true;

                if (!(typeof this.deleteItem !== 'function')) {
                  _context.next = 5;
                  break;
                }

                console.warn('deleteItem function is not defined');
                return _context.abrupt("return");

              case 5:
                _context.next = 7;
                return this.deleteItem(this.itemToBeDeleted);

              case 7:
                this.itemToBeDeleted = null;

                if (this.deleteItemSnackMessage) {
                  this.$snack(this.deleteItemSnackMessage, 'success');
                } else {
                  this.$snack(this.$i18n_t('Core.ListViewPage.deleteItem.success.snackMessage'), 'success');
                }

                this.callFetchItems();
                _context.next = 17;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);
                this.itemToBeDeleted = null;
                this.deleteItemError = _context.t0;

                if (this.deleteItemErrorSnackMessage) {
                  this.$snack(this.deleteItemErrorSnackMessage, 'error');
                } else {
                  this.$snack(this.$i18n_t('Core.ListViewPage.deleteItem.error.snackMessage'), 'error');
                }

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 12]]);
      }));

      function callDeleteItem() {
        return _callDeleteItem.apply(this, arguments);
      }

      return callDeleteItem;
    }(),
    onClickDeleteItem: function onClickDeleteItem(item) {
      this.showDeletePrompt = true;
      this.itemToBeDeleted = item;
    },
    updateRouterParams: function () {
      var _updateRouterParams = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.$router.replace({
                  query: _objectSpread(_objectSpread({}, this.$route.query), params)
                });

              case 3:
                _context2.next = 8;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](0);
                console.error(_context2.t0);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 5]]);
      }));

      function updateRouterParams(_x) {
        return _updateRouterParams.apply(this, arguments);
      }

      return updateRouterParams;
    }(),
    callFetchItems: debounce( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _yield$this$fetchItem, items, total;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              this.isFetching = true;
              _context3.next = 4;
              return this.fetchItems(_objectSpread({
                search: this.textSearchValue,
                page: this.tablePaginationOptions.page,
                perPage: this.tablePaginationOptions.itemsPerPage,
                sortBy: this.tablePaginationOptions.sortBy[0],
                sortDirection: this.tablePaginationOptions.sortDesc[0] ? 'desc' : 'asc'
              }, this.externalFetchParams));

            case 4:
              _yield$this$fetchItem = _context3.sent;
              items = _yield$this$fetchItem.items;
              total = _yield$this$fetchItem.total;
              this.items = items;
              this.totalItemsCount = total;
              _context3.next = 15;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](0);
              console.error(_context3.t0);
              this.$snack(this.$i18n_t(this.fetchErrorMessage), 'error');

            case 15:
              _context3.prev = 15;
              this.isFetching = false;
              return _context3.finish(15);

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 11, 15, 18]]);
    })), FETCH_LIST_DEBOUNCE_TIME_MS),
    getValueByPath: function getValueByPath(obj, path) {
      return get(obj, path);
    },
    getItemHref: function getItemHref(item) {
      return typeof this.rowHref === 'function' ? this.rowHref(item) : '#';
    },
    navigateToRunner: function navigateToRunner(deviceSyncStatus, linkedVirtualDevices) {
      if (linkedVirtualDevices === 0) {
        return;
      }

      if (deviceSyncStatus.isRunning || !deviceSyncStatus.isRunning && deviceSyncStatus.syncFailed === true) {
        this.$router.push("/background-jobs/?tab=bg-jobs-edit&openRunnerId=".concat(deviceSyncStatus.backgroundRunnerId));
      }
    }
  }
};